import { render, staticRenderFns } from "./DuplicatedOrganizationModal.vue?vue&type=template&id=329a241f&"
import script from "./DuplicatedOrganizationModal.vue?vue&type=script&lang=js&"
export * from "./DuplicatedOrganizationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports